module.exports = __webpack_public_path__ + "img/afm.401357c7.jpg";